import { OrganizationStatus, SectionStatus } from '../../../core/constants/status.constants';

export const STATUS_LABELS: Record<string, string> = {
  [OrganizationStatus.NESSUNA_VERSIONE]: 'Nessuna versione',
  DRAFT: 'Bozza',
  IN_REVIEW: 'In Revisione',
  [OrganizationStatus.TO_BE_REVIEWED]: 'In Revisione',
  ACCEPTED: 'Accettato',
  REJECTED: 'Rifiutato',
  DELETION_REQUESTED: 'Richiesta di eliminazione',
  DELETION_REJECTED: 'Eliminazione rifiutata',
  [OrganizationStatus.WAITING_TO_BE_SIGNED]: 'In Attesa di Firma',
  [OrganizationStatus.COMPLETED]: 'Completato',
};

export const LEGACY_NO_STATUS = 'NO_STATUS';
export const STATUS_COUNTS_EMPTY_LABEL = 'Nessun documento';

export const getStatusLabel = (status?: string | null): string => {
  if (!status) return '';
  return STATUS_LABELS[status] ?? status;
};

export const getSubsectionStatusLabel = (status?: string | null): string => {
  if (!status) return '';
  if (status === SectionStatus.IN_REVIEW || status === OrganizationStatus.TO_BE_REVIEWED) {
    return 'In revisione';
  }
  return getStatusLabel(status);
};

export const getStatusCountLabel = (status?: string | null): string => {
  if (!status) return '';
  switch (status) {
    case OrganizationStatus.COMPLETED:
      return 'Accettato';
    case LEGACY_NO_STATUS:
    case SectionStatus.NO_STATUS:
    case OrganizationStatus.NESSUNA_VERSIONE:
      return 'Nessuno stato';
    default:
      return getStatusLabel(status);
  }
};
